import Vue from 'vue'

import { Colors, Services } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, labelModes, permissionPresets, popperPlacements, sizes } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import svg from '@/components/icon/svg'
import draggable from '@/components/misc/draggable'
import preloader from '@/components/preloader'
import routesCreateDirect from '@/components/services/routes/create/direct'
import routesCreateFull from '@/components/services/routes/create/full'
import sticker from '@/components/sticker'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'
import routesConditions from '@/components/trees/routes/conditions'
import { localServices, rowStatesIcon } from '@/components/trees/routes/utils'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder pa-5'
    },
    [ h(preloader) ]
  )
}

function renderEmpty(h) {
  return h(components.empty)
}

function renderTitle(h, { value, title }) {
  if (this.viewport.breakpoint.smUp || !this.showAddRouteMenu[value]) {
    return h(
      sticker,
      {
        props: {
          value: this.getTranslate(title),
          label: this.getTranslate(`${Services.routingGroups}.labels.type`),
          iconSVG: value,
          iconColor: Colors[value]
        }
      }
    )
  }
}
function renderAddButton(h, type) {
  let icon = 'add'
  let color = 'secondary'
  if (this.showAddRouteMenu[type]) {
    icon = 'keyboard_arrow_left'
    color = 'black'
  }

  return h(
    'div',
    {
      class: `${Services.routingGroups}-sendingType__add-button`
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            icon,
            color
          },
          on: {
            click: () => {
              this.clearShowAddRouteMenu(type)
              this.showAddRouteMenu[type] = !this.showAddRouteMenu[type]
            }
          }
        }
      )
    ]
  )
}
function renderDescriptionTag(h, value) {
  if (this.checkPermissions(`advanced.${Services.routingGroups}.get`, permissionPresets.true)) {
    if (value) {
      return h(
        'div',
        {
          class: 'fjcfs'
        },
        [
          h(
            tag,
            {
              props: {
                label: value,
                color: Colors.primary,
                size: sizes.tiny
              }
            }
          )
        ]
      )
    }
  }
}
function renderRoutingGroupSelector(h, type) {
  return h(
    components.select,
    {
      props: {
        value: this.routeSelector,
        label: this.getTranslate(`${Services.routingGroups}.labels.route`),
        itemsDisabled: this.RoutingGroups[type].map(({ id }) => {
          return id
        }),
        service: Services.routingGroups,
        query: {
          type,
          isActive: true
        },
        labelMode: labelModes.hidden,
        autocomplete: true,
        dense: true,
        details: false
      },
      scopedSlots: {
        item: ({ item }) => {
          return h(
            'div',
            {
              class: 'grid grid-gap--2'
            },
            [
              h(
                textOverflow,
                {
                  class: 'caption',
                  props: {
                    value: item.title
                  }
                }
              ),
              renderDescriptionTag.call(this, h, item._item.description)
            ]
          )
        }
      },
      on: {
        input: event => {
          this.addRoutingGroup(event, type)
        }
      }
    }
  )
}
function renderCreateMenu(h, type) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetSkidding: -34
      }
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            icon: icons.add,
            color: Colors.secondary
          },
          slot: 'activator'
        }
      ),

      h(
        components.list,
        {
          props: {
            dense: true,
            rounded: true
          }
        },
        [
          h(
            components['list-item'],
            {
              props: {
                label: this.getTranslate('routes.types.full'),
                dense: true
              },
              on: {
                click: () => {
                  this.showDialog.full[type] = true
                }
              }
            }
          ),

          h(
            components['list-item'],
            {
              props: {
                label: this.getTranslate('routes.types.direct'),
                dense: true
              },
              on: {
                click: () => {
                  this.showDialog.direct[type] = true
                }
              }
            }
          )
        ]
      )
    ]
  )
}
function renderAddMenuContent(h, type) {
  if (this.showAddRouteMenu[type]) {
    return h(
      'div',
      {
        class: `${Services.routingGroups}-sendingType__add-menu`
      },
      [
        renderRoutingGroupSelector.call(this, h, type),
        renderCreateMenu.call(this, h, type),

        h(
          routesCreateFull,
          {
            props: {
              show: this.showDialog.full[type],
              type
            },
            on: {
              input: event => {
                if (!~this.RoutingGroups[type].findIndex(item => {
                  return item.id === event
                })) {
                  this.RoutingGroups[type].push({ id: event })
                  this.fillRoutingGroups(true)
                }
              },
              showDialog: event => {
                if (typeof event === 'boolean') {
                  this.showDialog.full[type] = event
                }
              }
            }
          }
        ),
        h(
          routesCreateDirect,
          {
            props: {
              value: this.showDialog.direct[type],
              type
            },
            on: {
              input: event => {
                if (!~this.RoutingGroups[type].findIndex(item => {
                  return item.id === event
                })) {
                  this.RoutingGroups[type].push({ id: event })
                  this.fillRoutingGroups(true)
                }
              },
              showDialog: event => {
                if (typeof event === 'boolean') {
                  this.showDialog.direct[type] = event
                }
              }
            }
          }
        )
      ]
    )
  }
}
function renderAddMenu(h, type) {
  if (this.viewport.breakpoint.mdUp) {
    return h(
      'transition',
      {
        props: { name: 'route-show-menu' }
      },
      [ renderAddMenuContent.call(this, h, type) ]
    )
  }

  return renderAddMenuContent.call(this, h, type)
}
function renderAddRoutingGroup(h, value) {
  if (!this.readonly) {
    return h(
      'div',
      {
        class: {
          [`${Services.routingGroups}-sendingType__add`]: true

        }
      },
      [
        renderAddButton.call(this, h, value),
        renderAddMenu.call(this, h, value)
      ]
    )
  }
}
function renderSendingType(h, { title, value }) {
  return h(
    'div',
    {
      class: {
        [`${Services.routingGroups}-sendingType`]: true,
        [`${Services.routingGroups}-sendingType--open`]: this.showAddRouteMenu[value]
      }
    },
    [
      renderTitle.call(this, h, {
        title,
        value
      }),

      renderAddRoutingGroup.call(this, h, value)
    ]
  )
}

function renderRowTitleWithType(h, value, type) {
  return h(
    'div',
    {
      class: [
        [ `${Services.routingGroups}-tree-row__title` ],
        [ `${Services.routingGroups}-tree-row__title--${type}` ]
      ],
      directives: [
        {
          name: components.tooltip,
          options: {
            value: this.getTranslate(`${Services.sendings}.types.${type}`),
            placement: popperPlacements.top
          }
        }
      ]
    },
    [
      h(
        svg,
        {
          props: {
            value: type,
            color: Colors[type],
            size: 16
          }
        }
      ),
      h(
        textOverflow,
        {
          props: {
            value
          }
        }
      )
    ]
  )
}
function renderRowTitle(h, value) {
  return h(
    textOverflow,
    {
      props: {
        value
      }
    }
  )
}
function renderInfoTitle(h, title, type) {
  if (type) {
    return renderRowTitleWithType.call(this, h, title, type)
  }

  return renderRowTitle.call(this, h, title)
}
function renderAdditionalInfo(h, service, additionalInfo) {
  if (service === Services.providerGroups) {
    return h(
      tag,
      {
        props: {
          label: `${additionalInfo.percentage}%`,
          color: Colors.primary,
          size: sizes.tiny
        }
      }
    )
  }

  return h('div')
}
function renderTreeRowArrowIndicator(h, state, trigger) {
  if (trigger) {
    return h(
      'div',
      {
        class: 'faic fjcc square--28'
      },
      [
        h(
          components.icon,
          {
            props: {
              value: rowStatesIcon[state],
              size: 20,
              color: Colors.grey
            }
          }
        )
      ]
    )
  }
}
function renderTreeRowInfo(h, { title, service, type }, additionalInfo = {}) {
  return h(
    'div',
    {
      class: {
        [`${Services.routingGroups}-tree-row__info`]: true,
        [`${Services.routingGroups}-tree-row__info--type`]: !!type
      }
    },
    [
      renderInfoTitle.call(this, h, title, type),
      renderAdditionalInfo.call(this, h, service, additionalInfo)
    ]
  )
}
function renderTreeEntityLink(h, service, id) {
  return h(
    'router-link',
    {
      class: {
        'link link--passive link--no-active link--no-hover': true,
        'hover-child': this.viewport.breakpoint.mdUp
      },
      props: {
        to: {
          name: `${service}.single`,
          params: { id }
        }
      }
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.link,
            size: sizes.small,
            mode: buttonModes.flat
          }
        }
      )
    ]
  )
}
function renderTreeRow(h, { id, title, service, type }, additionalInfo = {}) {
  let state
  if (service !== 'providers') {
    state = this.getRowState(service, id)
  }

  return h(
    'div',
    {
      class: {
        [`${Services.routingGroups}-tree-row`]: true,
        [`${Services.routingGroups}-tree-row--${state}`]: !!state,
        [`${Services.routingGroups}-tree-row--${service}`]: !!service,
        'hover-parent hover-parent--opacity': true
      },
      on: {
        click: () => {
          return this.getEntities(service, localServices[service].association, id)
        },
        dblclick: () => {
          return this.getAllEntities(service, localServices[service].association, id)
        }
      }
    },
    [
      renderTreeRowArrowIndicator.call(this, h, state, service !== 'providers'),
      renderTreeRowInfo.call(this, h, {
        title,
        service,
        type
      }, additionalInfo),
      renderTreeEntityLink.call(this, h, service, id)
    ]
  )
}
function renderActiveIndicator(h, active = false) {
  if (active) {
    return h(
      squircle,
      {
        props: {
          value: icons.keyboard_double_arrow_right,
          color: Colors.epic
        }
      }
    )
  }
}
function renderProviders(h, parentId, parentActive = false) {
  if (Array.isArray(this.Providers[parentId]) && this.Providers[parentId].length) {
    const service = Services.providers

    return h(
      'div',
      {
        class: `${Services.routingGroups}-tree-${service}`
      },
      this.Providers[parentId].map(({ id, title }) => {
        return h(
          'div',
          {
            class: {
              [`${Services.routingGroups}-tree__section`]: true,
              [`${Services.routingGroups}-tree-provider`]: true,
              [`${Services.routingGroups}-tree-provider--active`]: !!this.highlight[service] && !!~this.highlight[service].indexOf(id) && parentActive
            }
          },
          [
            renderActiveIndicator.call(this, h, !!this.highlight[service] && !!~this.highlight[service].indexOf(id) && parentActive),
            renderTreeRow.call(this, h, {
              id,
              title,
              service
            })
          ]
        )
      })
    )
  }
}
function renderProviderGroups(h, parentId, parentActive = false) {
  if (Array.isArray(this.ProviderGroups[parentId]) && this.ProviderGroups[parentId].length) {
    const service = Services.providerGroups

    return h(
      'div',
      {
        class: `${Services.routingGroups}-tree-${service}`
      },
      this.ProviderGroups[parentId].map(({ id, title, percentage }) => {
        return h(
          'div',
          {
            class: {
              [`${Services.routingGroups}-tree__section`]: true,
              [`${Services.routingGroups}-tree__section--active`]: !!this.highlight[service] && !!~this.highlight[service].indexOf(id) && parentActive,
              [`${Services.routingGroups}-tree-providerGroup`]: true
            }
          },
          [
            renderTreeRow.call(this, h, {
              id,
              title,
              service
            }, { percentage }),

            h(
              'div',
              {
                class: {
                  [`${Services.routingGroups}-tree__holder`]: true,
                  [`${Services.routingGroups}-tree__holder--${this.getRowState(service, id)}`]: true
                }
              },
              [ renderProviders.call(this, h, id, !!this.highlight[service] && !!~this.highlight[service].indexOf(id) && parentActive) ]
            )
          ]
        )
      })
    )
  }
}

function renderConditions(h, rules) {
  if (Array.isArray(rules) && rules.length) {
    return h(
      'div',
      {
        class: `${Services.routingGroups}-tree-routingRule__conditions`
      },
      [ h(routesConditions, { props: { value: rules } }) ]
    )
  }
}
function renderRoutingRules(h, parentId, parentActive = false) {
  if (Array.isArray(this.RoutingRules[parentId]) && this.RoutingRules[parentId].length) {
    const service = Services.routingRules

    return h(
      'div',
      {
        class: `${Services.routingGroups}-tree-${service}`
      },
      this.RoutingRules[parentId].map(({ id, title, rules, type }) => {
        return h(
          'div',
          {
            class: {
              [`${Services.routingGroups}-tree__section`]: true,
              [`${Services.routingGroups}-tree__section--active`]: !!this.highlight[service] && !!~this.highlight[service].indexOf(id) && parentActive,
              [`${Services.routingGroups}-tree-routingRule`]: true
            }
          },
          [
            renderTreeRow.call(this, h, {
              id,
              title,
              service,
              type
            }),
            h(
              'div',
              {
                class: {
                  [`${Services.routingGroups}-tree__holder`]: true,
                  [`${Services.routingGroups}-tree__holder--${this.getRowState(service, id)}`]: true
                }
              },
              [
                renderConditions.call(this, h, rules),
                renderProviderGroups.call(this, h, id, !!this.highlight[service] && !!~this.highlight[service].indexOf(id) && parentActive)
              ]
            )
          ]
        )
      })
    )
  }
}

function renderDragHandler(h, state) {
  let value = 'drag_handle'
  if (this.readonly) {
    value = rowStatesIcon[state]
  } else if (state === 'loading') {
    value = rowStatesIcon.loading
  }

  return h(
    components.icon,
    {
      class: {
        drag_handle: !this.readonly,
        [`${Services.routingGroups}-tree-routingGroup--${state}`]: true
      },
      props: {
        value,
        color: Colors.grey
      }
    }
  )
}
function renderRoutingGroupInfo(h, title, description) {
  return h(
    'div',
    {
      class: `${Services.routingGroups}-tree-routingGroup__info`
    },
    [
      renderInfoTitle.call(this, h, title),
      renderDescriptionTag.call(this, h, description)
    ]
  )
}
function renderRoutingGroupLinkButton(h, id) {
  let size = sizes.medium
  if (this.viewport.breakpoint.lgUp) {
    size = sizes.small
  }

  return h(
    'router-link',
    {
      class: 'link link--passive link--no-active link--no-hover',
      props: {
        to: {
          name: `${Services.routingGroups}.single`,
          params: { id }
        }
      }
    },
    [
      h(
        button,
        {
          props: {
            mode: buttonModes.flat,
            icon: icons.link,
            size
          }
        }
      )
    ]
  )
}
function renderRoutingGroupRemoveButton(h, id, value) {
  if (!this.readonly) {
    let size = sizes.medium
    if (this.viewport.breakpoint.lgUp) {
      size = sizes.small
    }

    return h(
      components.menu,
      {
        props: {
          value: this.showConfirmRemoveDialog[id],
          rounded: true,
          offsetDistance: 8,
          placement: popperPlacements['bottom-end']
        }
      },
      [
        h(
          button,
          {
            props: {
              mode: buttonModes.flat,
              icon: icons.remove,
              color: Colors.error,
              size,
              tooltip: this.getTranslate(`${Services.routingGroups}.tooltips.remove`)
            },
            key: id,
            on: {
              click: event => {
                event.stopPropagation()
                Vue.set(this.showConfirmRemoveDialog, id, true)
              }
            },
            slot: 'activator'
          }
        ),

        h(
          'div',
          {
            class: 'flex grid-gap--8 pa-2'
          },
          [
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.close'),
                  size: sizes.small,
                  mode: buttonModes.flat
                },
                on: {
                  click: () => {
                    Vue.set(this.showConfirmRemoveDialog, id, false)
                  }
                }
              }
            ),
            h(
              button,
              {
                props: {
                  label: this.getTranslate('misc.buttons.remove'),
                  size: sizes.small,
                  mode: buttonModes.flat,
                  color: Colors.error
                },
                on: {
                  click: () => {
                    this.removeRoutingGroup(id, value)
                  }
                }
              }
            )
          ]
        )
      ]
    )
  }
}
function renderRoutingGroupButtons(h, id, value) {
  let gridTemplateColumns = 'repeat(2, auto)'
  if (this.readonly) {
    gridTemplateColumns = 'auto'
  }

  return h(
    'div',
    {
      class: {
        [`${Services.routingGroups}-tree-routingGroup__buttons`]: true,
        'hover-child': this.viewport.breakpoint.mdUp && !this.showConfirmRemoveDialog[id]
      },
      style: {
        gridTemplateColumns
      }
    },
    [
      renderRoutingGroupLinkButton.call(this, h, id),
      renderRoutingGroupRemoveButton.call(this, h, id, value)
    ]
  )
}
function renderRoutingGroupHeader(h, value, { id, title, description }) {
  return h(
    'div',
    {
      class: `${Services.routingGroups}-tree-routingGroup__header hover-parent hover-parent--opacity`,
      on: {
        click: event => {
          this.clickRow(event, this.getEntities(Services.routingGroups, localServices[Services.routingGroups].association, id))
        },
        dblclick: event => {
          this.clickRow(event, this.getAllEntities(Services.routingGroups, localServices[Services.routingGroups].association, id))
        }
      }
    },
    [
      renderDragHandler.call(this, h, this.getRowState(Services.routingGroups, id)),
      renderRoutingGroupInfo.call(this, h, title, description),
      renderRoutingGroupButtons.call(this, h, id, value)
    ]
  )
}
function renderRoutingGroup(h, value, { id, title, description }) {
  return h(
    'div',
    {
      class: {
        [`${Services.routingGroups}-tree-routingGroup`]: true,
        [`${Services.routingGroups}-tree-routingGroup--active`]: !!this.highlight.routingGroups && !!~this.highlight.routingGroups.indexOf(id)
      }
    },
    [
      renderRoutingGroupHeader.call(this, h, value, {
        id,
        title,
        description
      }),

      h(
        'div',
        {
          class: {
            [`${Services.routingGroups}-tree__holder`]: true,
            [`${Services.routingGroups}-tree__holder--${this.getRowState(Services.routingGroups, id)}`]: true
          }
        },
        [ renderRoutingRules.call(this, h, id, !!this.highlight.routingGroups && !!~this.highlight.routingGroups.indexOf(id)) ]
      )
    ]
  )
}
function renderRoutingGroups(h, { value }) {
  if (Array.isArray(this.RoutingGroups[value]) && this.RoutingGroups[value].length) {
    return h(
      draggable,
      {
        class: `${Services.routingGroups}-tree`,
        props: {
          value: this.RoutingGroups[value],
          handle: 'drag_handle',
          disabled: this.readonly
        },
        scopedSlots: {
          item: item => {
            return renderRoutingGroup.call(this, h, value, item)
          }
        },
        on: {
          input: event => {
            this.RoutingGroups[value] = event
          }
        }
      }
    )
  }
}

function renderType(h, type) {
  return h(
    'div',
    {
      class: `${Services.routingGroups}-tab__item`
    },
    [
      renderSendingType.call(this, h, type),
      renderRoutingGroups.call(this, h, type)
    ]
  )
}
function renderTypes(h) {
  return this.types.map(type => {
    return renderType.call(this, h, type)
  })
}

function renderContent(h) {
  if (this.loading && this.hasSelectedRoutingGroups) {
    return [ renderPreloader.call(this, h) ]
  }

  if (!this.hasRoutingGroups && this.readonly) {
    return [ renderEmpty.call(this, h) ]
  }

  return renderTypes.call(this, h)
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.routingGroups}-tab`
    },
    renderContent.call(this, h)
  )
}
